import { render, staticRenderFns } from "./the-nav-drawer.vue?vue&type=template&id=f990c880&scoped=true&"
import script from "./the-nav-drawer.vue?vue&type=script&lang=js&"
export * from "./the-nav-drawer.vue?vue&type=script&lang=js&"
import style0 from "./the-nav-drawer.vue?vue&type=style&index=0&id=f990c880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f990c880",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDivider,VNavigationDrawer,VTooltip})
